/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Override_BtnInputs */



/**
* | output |
* | --- |
* | "Override" |
*
* @param {Override_BtnInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const override_btn = /** @type {((inputs?: Override_BtnInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Override_BtnInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Modifier")
	if (locale === "es") return /** @type {LocalizedString} */ ("Anular")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Substituir")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sovrascrivi")
	return /** @type {LocalizedString} */ ("Override")
});